import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-clipboard-list-icon',
  templateUrl: './communication-clipboard-list.component.html'
})
export class CommunicationClipboardListComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
